<div class="customers">
    <div>
        <div class="card-body">
            
            <div class="row" style="display: flex; justify-content: space-between; align-items: center;">
                <div class="separator" [ngClass]="'color-back-area-' + areaNumber" style="width: 100%; margin-left: 0px; margin-bottom: 10px; margin-right: -15px; display: flex; justify-content: space-between; align-items: center;">
                    <div class="estrategia-text">
                        <strong>{{subdimensionData?.subDimension}}</strong>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="separator" style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                    <p class="objetivo-text"><strong>OBJETIVO: </strong> {{subdimensionData.objetivo}}</p>
                </div>
            </div>
            <div class="row">
                <div class="separator" style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                    <p class="objetivo-text"><strong>META: </strong> {{subdimensionData.meta}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12" style="background-color: #E8EAF5;">
                    <app-pme-estrategia1-fase-anual [indice]="indice" [estadoData]="estadoData" [subdimensionData]="subdimensionData" [areaNumber]="dimensionData.orden" [simulacion]="simulacion" ></app-pme-estrategia1-fase-anual>

                    <app-pme-estrategia2-fase-anual [indice]="indice" [estadoData]="estadoData" [subdimensionData]="subdimensionData" [areaNumber]="dimensionData.orden" [simulacion]="simulacion" ></app-pme-estrategia2-fase-anual>
                </div>
            </div>
        </div>
    </div>
</div>